import { beginApiCall, apiCallError } from 'redux/actions/apiStatusActions';
import * as reportApi from 'api/reportApi';
import * as types from './actionTypes';

export function getReportData(filter) {
  return async dispatch => {
    dispatch(beginApiCall());
    dispatch({ type: types.GET_REPORT_REQUEST });
    try {
      const data = await reportApi.getReportData(filter); // Pass filter here
      dispatch({ type: types.GET_REPORT_SUCCESS, data });
    } catch (e) {
      dispatch({ type: types.GET_REPORT_FAILED, e });
      const { error } = await e.response?.json();
      dispatch(apiCallError(error));
      throw error;
    }
  };
}
